import * as React from "react";
type Props = {
  className?: string,
};
function SvgFridge({ className }: Props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="utility-Fridge"
      className={className}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7 2C5.34315 2 4 3.34315 4 5V19C4 20.6569 5.34315 22 7 22H17C18.6569 22 20 20.6569 20 19V5C20 3.34315 18.6569 2 17 2H7ZM6 5C6 4.44772 6.44772 4 7 4H17C17.5523 4 18 4.44772 18 5V10H6V5ZM6 12V19C6 19.5523 6.44772 20 7 20H17C17.5523 20 18 19.5523 18 19V12H6ZM14.5 18.5V13.5H16.5V18.5H14.5ZM14.5 5.5V8.5H16.5V5.5H14.5Z"
        fill="#214E33"
      />
    </svg>
  );
}
export default SvgFridge;
